import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EmergencyBookingView } from './EmergencyBookingView';
import { header5DefinitionJSON, header5NewUserJSON } from './StartPage';

const problems = [
  'swelling',
  'dental pain',
  'bleeding',
  'broken tooth',
  'lost filling',
  'lost crown or bridge',
  'problems after dental surgery',
  'sensitivity to hot or cold',
  'braces or aligner emergency',
];

// Placeholder for forwarding the selected problem to the booking backend.
export const enterProblem = (problem: string) => {
  console.log('Emergency problem:', problem);
};

export function EmergencyPage() {
  const hasLoginPatientId = Boolean(localStorage.getItem('loginPatientId'));
  localStorage.setItem('headerDefinition', hasLoginPatientId ? header5DefinitionJSON : header5NewUserJSON);
  localStorage.setItem('headerPhase', '1');

  const navigate = useNavigate();
  const [selectedProblems, setSelectedProblems] = useState<string[]>([]);
  const [selectedRegion, setSelectedRegion] = useState<string[]>([]);
  const canContinue = selectedProblems.length > 0 && selectedRegion.length === 2;

  useEffect(() => {
    localStorage.setItem(
      'selectedPainRegion',
      selectedRegion.length > 0 ? JSON.stringify(selectedRegion) : ''
    );
  }, [selectedRegion]);

  useEffect(() => {
    localStorage.setItem('selectedPainProblems', JSON.stringify(selectedProblems));
  }, [selectedProblems]);

  const toggleProblem = (problem: string) => {
    enterProblem(problem);
    setSelectedProblems((current) => {
      const next = current.includes(problem)
        ? current.filter((item) => item !== problem)
        : [...current, problem];
      return next;
    });
  };

  const selectRegion = (vertical: string, horizontal: string) => {
    setSelectedRegion((current) =>
      current[0] === vertical && current[1] === horizontal ? [] : [vertical, horizontal]
    );
  };

  const back = () => navigate('/procedures');

  const next = () => {
    if (!canContinue) return;
    localStorage.setItem('previousPage', '/emergency');
    navigate('/practitioners');
  };

  return (
    <EmergencyBookingView
      problems={problems}
      selectedProblems={selectedProblems}
      selectedRegion={selectedRegion}
      canContinue={canContinue}
      onToggleProblem={toggleProblem}
      onSelectRegion={selectRegion}
      onBack={back}
      onNext={next}
    />
  );
}
